<template>
    <div>
        <el-row v-if="product_compare.length > 0">
            <el-table :data="product_compare" border style="width:97%">
                <el-table-column label="基本设置" prop="name"></el-table-column>
                <el-table-column label="修改前" prop="before" ></el-table-column>
                <el-table-column label="修订后" prop="after" class-name="red-text"></el-table-column>
            </el-table>
        </el-row>
        <el-row v-if="column_compare.length > 0">
            <el-table :data="column_compare" border style="width:97%">
                <el-table-column label="栏目限制" prop="name"></el-table-column>
                <el-table-column label="修改前" prop="before" ></el-table-column>
                <el-table-column label="修订后" prop="after" class-name="red-text"></el-table-column>
            </el-table>
        </el-row>
        <el-row v-if="quota_compare.length > 0">
            <el-table :data="quota_compare" border style="width:97%">
                <el-table-column label="额度限制" prop="name"></el-table-column>
                <el-table-column label="修改前" prop="before" ></el-table-column>
                <el-table-column label="修订后" prop="after" class-name="red-text"></el-table-column>
            </el-table>
        </el-row>
        <el-row v-if="device_compare.length > 0">
            <el-table :data="device_compare" border style="width:97%">
                <el-table-column label="设备信息" prop="name"></el-table-column>
                <el-table-column label="修改前" prop="before" ></el-table-column>
                <el-table-column label="修订后" prop="after" class-name="red-text"></el-table-column>
            </el-table>
        </el-row>
    </div>
</template>
<style>
.red-text {
  color: red;
}
</style>
<script>
    import Time from '~/common/time';
    export default {
        name: "vr",
        props: {
            edit_content: {
                required: true
            }
        },
        created() {
            this.getProductCompare();
            this.getColumnCompare();
            this.getQuotaCompare();
            this.getDeviceCompare();
        },
        data() {
            return {
                product_compare: [],
                column_compare: [],
                quota_compare: [],
                device_compare: [],
                product_type: {
                    '1': '试用',
                    '2': '新增',
                    '3': '续费',
                },
                mode_type: {
                    '1': '仅按学段控制',
                    '2': '仅按学段-学科控制',
                },
                xueduan_type: {
                    '1': '小学',
                    '2': '初中',
                    '3': '高中',
                    '4': '中职',
                },
                subject_type: {
                    '2': '语文',
                    '3': '数学',
                    '4': '英语',
                    '5': '科学',
                    '20': '历史与社会(人文地理)',
                    '6': '物理',
                    '7': '化学',
                    '8': '历史',
                    '9': '道德与法治',
                    '1015': '思想政治',
                    '21': '社会法治',
                    '10': '地理',
                    '11': '生物学',
                    '99': '跨科',
                    '19': '基本能力',
                    '16': '劳动',
                    '15': '通用技术',
                    '14': '信息技术',
                    '12': '综合',
                    '18': '专题教育',
                    '1006': '音乐',
                    '1008': '美术',
                    '1010': '体育与健康',
                    '1012': '心理健康',
                    '1016': '中职专业课',
                    '1013': '职业技能大赛',
                    '1017': '班会',
                    '1019': '地方、校本课程',
                    '1021': '综合实践活动',
                },
            }
        },
        methods: {
            getHtml(title, before, after){
                return {
                    name: title,
                    before: before,
                    after: after,
                };
            },
            formatTimestamp(timestamp) {
                if(timestamp < 1) {
                    return '';
                }
                const date = new Date(timestamp);
                const year = date.getFullYear();
                const month = String(date.getMonth() + 1).padStart(2, "0");
                const day = String(date.getDate()).padStart(2, "0");
                return `${year}-${month}-${day}`;
            },

            // 基本设置修改列表
            getProductCompare() {
                //修改前的数据内容
                let before_content = this.edit_content.before_content;
                //修改后的数据内容
                let after_content = this.edit_content.content;
                if(before_content.type != after_content.type){
                    this.product_compare.push(this.getHtml('订单类型', this.product_type[before_content.type], this.product_type[after_content.type]));
                }
                if(before_content.is_enable != after_content.is_enable){
                    this.product_compare.push(this.getHtml('产品开关', before_content.is_enable ? '开启' : '关闭', after_content.is_enable ? '开启' : '关闭'));
                }
                let before_start_at = before_content.start_at > 0 ? Time.asDateDay(before_content.start_at) : '';
                let before_end_at = before_content.end_at > 0 ? Time.asDateDay(before_content.end_at - 86400 * 1000) : '';
                let after_start_at = after_content.start_at > 0 ? Time.asDateDay(after_content.start_at) : '';
                let after_end_at = after_content.end_at > 0 ? Time.asDateDay(after_content.end_at) : '';
                if(before_start_at != after_start_at){
                    this.product_compare.push(this.getHtml('开始时间', before_start_at, after_start_at));
                }
                if(before_end_at != after_end_at){
                    this.product_compare.push(this.getHtml('结束时间', before_end_at, after_end_at));
                }
                if(before_content.memo != after_content.memo){
                    this.product_compare.push(this.getHtml('备注', before_content.memo, after_content.memo));
                }
            },

            // 栏目限制修改列表
            getColumnCompare() {
                let before_content = this.edit_content.before_content.column_config;
                let after_content = this.edit_content.content.column_config;
                if(before_content.pattern != after_content.mode){
                    this.column_compare.push(this.getHtml('模式', this.mode_type[before_content.pattern], this.mode_type[after_content.mode]));
                }
                let before_xueduan = before_content.stage.split(',');
                const before_xueduan_id_array = before_xueduan.slice().sort();
                const after_xueduan_id_array = after_content.xueduan.slice().sort();
                if(JSON.stringify(before_xueduan_id_array) !== JSON.stringify(after_xueduan_id_array)){
                    let before_xueduan_name_array = [];
                    let after_xueduan_name_array = [];
                    before_xueduan_id_array.forEach(xueduan_id => {
                        before_xueduan_name_array.push(this.xueduan_type[xueduan_id]);
                    });
                    after_xueduan_id_array.forEach(xueduan_id => {
                        after_xueduan_name_array.push(this.xueduan_type[xueduan_id]);
                    });
                    this.column_compare.push(this.getHtml('学段', before_xueduan_name_array.join(','), after_xueduan_name_array.join(',')));
                }
                if(before_content.subject_list.length == 4 && after_content.subject_list.length == 4){
                    for (let i = 0; i < 4; i++) {
                        const before_subject = before_content.subject_list[i].ids.slice().sort();
                        const after_subject = after_content.subject_list[i].ids.slice().sort();
                        if(JSON.stringify(before_subject) !== JSON.stringify(after_subject)){
                            let before_subject_name_array = [];
                            let after_subject_name_array = [];
                            before_subject.forEach(xueduan_id => {
                                before_subject_name_array.push(this.subject_type[xueduan_id]);
                            });
                            after_subject.forEach(xueduan_id => {
                                after_subject_name_array.push(this.subject_type[xueduan_id]);
                            });
                            this.column_compare.push(this.getHtml('学科-' + this.xueduan_type[i + 1], before_subject_name_array.join(','), after_subject_name_array.join(',')));
                        }
                    }
                }
            },

            // 额度限制修改列表
            getQuotaCompare() {
                let before_content = this.edit_content.before_content.quota_config;
                let after_content = this.edit_content.content.quota_config;
                if(before_content.length != after_content.length) {
                    return false;
                }
                after_content.forEach((item, key) => {
                    this.getQuotaCompareArray(before_content[key], item);
                });
            },

            // 设备信息修改列表
            getDeviceCompare() {
                let before_content = this.edit_content.before_content.device_config;
                let after_content = this.edit_content.content.device_config;
                let before_ids = [];
                let after_ids = [];
                before_content.forEach((item, key) => {
                    before_ids.push(item.device_id);
                });
                after_content.forEach((item, key) => {
                    after_ids.push(item.device_id);
                });

                const delete_ids = this.differenceArray(before_ids, after_ids);
                if(delete_ids.length > 0){
                    this.device_compare.push(this.getHtml('删除设备', before_ids.join(','), delete_ids.join(',')));
                }
                const add_ids = this.differenceArray(after_ids, before_ids);
                if(add_ids.length > 0){
                    this.device_compare.push(this.getHtml('添加设备', before_ids.join(','), add_ids.join(',')));
                }
            },


            getQuotaCompareArray(before_content, after_content){
                if(before_content.teach_quota != after_content.teach_quota){
                    this.quota_compare.push(this.getHtml(before_content.title + ' - Web端实验示教限制（次）', before_content.teach_quota, after_content.teach_quota));
                }
                if(before_content.issue_quota != after_content.issue_quota){
                    this.quota_compare.push(this.getHtml(before_content.title + ' - Web端发布示教限制（次）', before_content.issue_quota, after_content.issue_quota));
                }
                if(before_content.exam_quota != after_content.exam_quota){
                    this.quota_compare.push(this.getHtml(before_content.title + ' - Web端发布考试限制（次）', before_content.exam_quota, after_content.exam_quota));
                }
            },


            differenceArray(array1, array2) {
                return array1.filter(item => !array2.includes(item));
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/recoder/vr.vue